import React from 'react'
import { useParams } from 'react-router-dom'
import { SpotifyProductionWrapper } from '../components/qr/SpotifyProductionWrapper'

export default function SpotifyPage() {
  const { slug, accountSlug } = useParams<{ slug: string; accountSlug?: string }>()
  
  return (
    <div className="h-screen">
      <SpotifyProductionWrapper 
        linkId={slug}
        accountSlug={accountSlug}
        isPreview={false}
      />
    </div>
  )
}
